import { Stack } from "@altimateai/lego";
import AuthSlider from "../authCarousel";
import { Logo } from "../logo";
import MobileBaseContainer from "./MobileBaseContainer";

interface BaseContainerProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const BaseContainer = ({ children, footer }: BaseContainerProps) => {
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    return (
      <MobileBaseContainer footer={footer}>{children}</MobileBaseContainer>
    );
  }

  return (
    <div className="al-w-full al-h-full al-grid al-grid-cols-2 al-m-0">
      <div className="al-p-0">
        <AuthSlider />
      </div>
      <div className="al-p-0 al-h-full al-overflow-y-auto">
        <Stack direction="column" align="center" className="al-py-[8vh]">
          <div className="al-w-[60%]">
            <Logo />
          </div>
          <div className="al-min-h-[60px] al-flex-grow" />
          <Stack direction="column" className="al-w-[60%]">
            {children}
          </Stack>

          <div className="al-min-h-[60px] al-flex-grow-[2]" />
          {footer && <div className="al-w-[60%]">{footer}</div>}
        </Stack>
      </div>
    </div>
  );
};

export default BaseContainer;
